import HomePage from "@/views/HomePage";
import PatientListPage from "@/views/patient/PatientListPage";
import PatientDetailPage from "@/views/patient/PatientDetailPage";
import NotFoundPage from "@/views/NotFoundPage";
import PatientAddPage from "@/views/patient/PatientAddPage";
import SurgeryAddPage from "@/views/surgery/SurgeryAddPage";
import SurgeryDetailPage from "@/views/surgery/SurgeryDetailPage";
import PatientDetailSurgeriesPage from "@/views/patient/PatientDetailSurgeriesPage";
import PatientDetailPreviousSurgeriesPage from "@/views/patient/PatientDetailPreviousSurgeriesPage";
import SurgeryFinalEvaluationPage from "@/views/surgery/SurgeryFinalEvaluationPage";
import DocumentationPage from "@/views/DocumentationPage";
import AboutCookiesPage from "@/views/cookies/AboutCookiesPage";
import CookiePolicyPage from "@/views/cookies/CookiePolicyPage";
import LegalNotePage from "@/views/LegalNotePage";
import PasswordChangePage from "@/views/PasswordChangePage";
import ContactPage from "@/views/ContactPage";

const parseIntegerKeys = (route) => {
    const keys = ['patientId', 'surgeryId'];
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (route.params.hasOwnProperty(key)) {
            route.params[key] = parseInt(route.params[key]);
        }
    }
    return route.params;
};

export const routes = [
    {
        path: '/',
        name: 'home',
        component: HomePage,
    },
    {
        path: '/password-change/',
        name: 'password-change',
        component: PasswordChangePage,
    },
    {
        path: '/patients/',
        name: 'patients',
        component: PatientListPage,
    },
    {
        path: '/patients/add/',
        name: 'patient-add',
        component: PatientAddPage,
    },
    {
        path: '/patients/edit/:patientId/',
        name: 'patient-edit',
        component: PatientAddPage,
        props: parseIntegerKeys,
    },
    {
        path: '/patient/:patientId/',
        component: PatientDetailPage,
        props: (route) => ({...parseIntegerKeys(route), isSurgeryDetail: route.name === 'surgery-detail'}),
        children: [
            { path: '', redirect: 'surgeries/' },
            {
                path: 'surgeries/',
                name: 'patient-detail-surgeries',
                component: PatientDetailSurgeriesPage,
            },
            {
                path: 'previous-surgeries/',
                name: 'patient-detail-previous-surgeries',
                component: PatientDetailPreviousSurgeriesPage,
            },
        ],
    },
    {
        path: '/surgery/:surgeryId/finalevaluation',
        name: 'surgery-final-evaluation',
        component: SurgeryFinalEvaluationPage,
        props: parseIntegerKeys,
    },
    {
        path: '/surgery/add/:patientId/',
        name: 'surgery-add',
        component: SurgeryAddPage,
        props: parseIntegerKeys,
    },
    {
        path: '/surgery/:surgeryId/',
        name: 'surgery-detail',
        component: SurgeryDetailPage,
        props: parseIntegerKeys,
    },
    {
        path: '/documentation/',
        name: 'documentation',
        component: DocumentationPage,
    },
    {
        path: '/cookies/policy/',
        name: 'cookies-policy',
        component: CookiePolicyPage,
    },
    {
        path: '/cookies/about/',
        name: 'cookies-page',
        component: AboutCookiesPage,
    },
    {
        path: '/legal-note/',
        name: 'legal-note',
        component: LegalNotePage,
    },
    {
        path: '/contact/',
        name: 'contact',
        component: ContactPage,
    },
    {
        path: '*',
        component: NotFoundPage,
    },
];
